import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, QueryList, ViewChild, ViewChildren, SimpleChanges } from '@angular/core';
//import { UniqueChartService } from './unique-chart.service';
import { TableViewService } from '../../table-view.service';
import html2canvas from 'html2canvas';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { normalizePercentage } from 'src/app/modules/snapshot/custom-snapshot-chart-modules/chart-value.util';

@Component({
selector: 'app-Fill-chart',
  templateUrl: './fillchartwidget.component.html',
  styleUrls: ['./fillchartwidget.component.scss']
})
export class FillchartwidgetComponent implements AfterViewInit, OnDestroy {
  @ViewChild('parentDiv') parentDiv!: ElementRef;
  @ViewChild('parentDiv2') parentDiv2!: ElementRef;
  @ViewChild('parentDiv3') parentDiv3!: ElementRef;
  data: any = [];
  data2:any =[];
  customcolors: any =this.uniquechartservice.customColors;
  name: any = [];
  datalabel: any = [];
  cov: any = [];
  percentage: any =[];
  Indexvalues:any =[];
  significance: any = [];
  significance2: any = [];
  SignificanceValue:any =[];
  sampleSizes: any = [];
  filldirection: string = 'vertical';
  fillColor: any = [];
  darkTheme: boolean = false;
  userselectedchartdata: any;

  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;
  @Input() widgetCount:any;

  constructor(
    private http: HttpClient,
    private uniquechartservice: TableViewService,
    private cdr: ChangeDetectorRef,
    private _customSnapshotService: CustomsnapshotService,
    private route: ActivatedRoute,
    private _configService: SnapshotService
  ) { }

isSingleLine: boolean[] = [];
  jsondata: any;
  seriescolor: any;
  seriesgradientcolor: any;
  chartproperties: any;
  samplesizeconstant: any;
  configuredProperties: any;
  maxdata: any;
  filltomax:boolean=false;
  fillChartPage: number = 0;
  // itemsPerPage: number = 2;
  isLoading=true;
  notApplicable=false;
  private subscriptions: Subscription = new Subscription();
  private updateSigSub: Subscription | null = null;
  DefaultConfidenceLevel: any = "";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  significanceValue: any;
  significanceValue2: any;
  chartMainData: any = [];
  @ViewChildren('categoryDiv') categoryDivs: QueryList<ElementRef> | undefined;
  ngOnInit(): void {
   
    this.isLoading=true;
      if (this.isOutput) {
          this.configuredProperties = JSON.parse(this.customData.customizationProperties);
          this.customData = this.customData.metric[0];
          this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
          this.subscriptions.add(
            this._configService.confedenceValue.subscribe(value => {
              this.DefaultConfidenceLevel = value;
              this.updateSig();
            }));
          this.subscriptions.add(
            this._configService.significanceValue.subscribe(value => {
              this.significanceValue = value;
              this.updateSig();
            }));
            this.isLoading=false;
      }
      else{
           this.http
            .get<any>('assets/Data/fillChartData.json')
            .subscribe((data) => {
              this.jsondata = data[0];
              this.chartproperties = this.jsondata['properties'][0];
              this.seriescolor = this.uniquechartservice.color;
              // this.seriesgradientcolor = this.uniquechartservice.linearGradients;
              // this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
              this.route.paramMap.subscribe((params) => {
                const userData = history.state.userData;
                this.userselectedchartdata = userData; // Use the userData object as needed
                if (this.userselectedchartdata?.widgetEditSelection) {
                  if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
                    this.chartproperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
                  }
                }
              });
              this.plotChart(
                this.jsondata['data'],
                this.chartproperties
              );
              this.isLoading=false;
            });
      }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData'] && !changes['customData'].firstChange) {
      this.fillChartPage = 0; 
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.customData = this.customData.metric[0];
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.updateSig();
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.categoryDivs?.forEach((div, i) => {
        const el = div.nativeElement;
        let lineHeightStr = getComputedStyle(el).lineHeight;
        let lineHeight = parseFloat(lineHeightStr);
        
        // Fallback if lineHeight is NaN (e.g., when set to "normal")
        if (isNaN(lineHeight)) {
          lineHeight = parseFloat(getComputedStyle(el).fontSize) * 1.2; // Use font-size * line-height ratio
        }
        
        this.isSingleLine[i] = el.offsetHeight <= lineHeight + 2;
      });
      this.cdr.detectChanges(); // Trigger change detection to apply the class
    }, 100); // Small delay to ensure DOM is fully rendered
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http.get<any>('assets/Data/fillChartData.json').subscribe((data) => {
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
         this.seriescolor = this.uniquechartservice.color;
         this.chartproperties.dataLabelSize=this.chartproperties.dataLabelSize-0.2;
        // this.seriesgradientcolor = this.piechartservice.linearGradients1;
        // this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.dataLabelPosition = 'right';
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
                this.plotChart(
                  this.jsondata['data'],
                  this.chartproperties
                );
      });
  }

  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
        
    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? normalizePercentage(dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? normalizePercentage(dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label":dataArr.data == null ? "NA": (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? normalizePercentage(dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient

          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev2.option,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? normalizePercentage(dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? normalizePercentage(dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data == null ? "NA" : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? normalizePercentage(dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            //  "color": dataArr.color,
            // "colorLinearGradient": dataArr.colorLinearGradient
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }


  // customization() {
  //   let custom: any = this.uniquechartservice.customizationFillChartWidget1();
  //   return custom;
  // }

  // preparechartdata(data: any) {
  //   if(this.isOutput){
  //     this.data=[];
  //     this.name=[];
  //     this.data2=[];
  //     this.cov=[];
  //     this.significance=[]; 
  //     this.significance2=[];  
  //     this.percentage=[];
  //     this.Indexvalues=[];
  //     this.SignificanceValue=[];
  //     this.sampleSizes=[];
  //     data.forEach((dat: any) => {
  //       let value =
  //           dat['Rounded Value'] == 0 ||
  //             dat['Rounded Value'] == null || dat['Rounded Value'] == 'NA'
  //             ? 0
  //             : parseFloat(dat['Rounded Value']);
  //       // Suppress value for non-superadmin below ISthreshold
  //       const sampleSizeVal = dat["Sample size"];
  //       if (this._configService.userRole != 'superadmin' && Number(sampleSizeVal) <= this._configService.ISthreshold) {
  //         value = 0;
  //       }
  //       this.data.push(dat['Rounded Value']);
  //       this.data2.push(value); // suppressed value used for rendering
  //       this.name.push(dat['Series Name']);
  //       this.cov.push(dat["Change value vs PY"]);
  //       this.significance.push(dat["Sig_LowerLimt"]);
  //       this.significance2.push(dat["Sig_UpperLimt"]);
  //       this.percentage.push(dat["isPercentage"]);
  //       this.Indexvalues.push(dat["ActualIndexValue"]);
  //       this.SignificanceValue.push(dat["Significance_Value"]);
  //       this.sampleSizes.push(dat["Sample size"]);
  //     });
  //     this.maxdata = Math.max(...this.data);
  //   }
  //   else{
  //       this.data=[];
  //       this.name=[];
  //       this.data2=[];
  //       this.cov=[];
  //       this.significance=[]; 
  //       this.significance2=[];  
  //       this.sampleSizes=[];
  //       data.forEach((dat: any) => {
  //         let value =
  //           parseFloat(dat['Rounded Value']) == 0 ||
  //             parseFloat(dat['Rounded Value']) == null
  //             ? 0
  //             : parseFloat(dat['Rounded Value']);
  //         this.data.push(value);
  //         this.data2.push(value);
  //         this.name.push(dat['Category Name']);
  //         this.cov.push(dat["Change value vs PY"]);
  //         this.significance.push(dat["Significance"]);
  //         this.significance2.push(dat["Significance2"]);
  //         // No explicit sample size in demo JSON; push 0 as placeholder
  //         this.sampleSizes.push(0);
  //       });
  //       this.maxdata = Math.max(...this.data);
  //   }
  // }
  // ...existing code...
  preparechartdata(data: any) {
    // initialize color array
    this.fillColor = [];
    // determine if gradients are available
    const isGradient = !!this.seriesgradientcolor && this.seriesgradientcolor.length > 0;

    if(this.isOutput){
      this.data=[];
      this.name=[];
      this.data2=[];
      this.cov=[];
      this.significance=[]; 
      this.significance2=[];  
      this.percentage=[];
      this.Indexvalues=[];
      this.SignificanceValue=[];
      this.sampleSizes=[];
      let i = 0;
      data.forEach((dat: any) => {
        let value =
            dat['Rounded Value'] == 0 ||
              dat['Rounded Value'] == null || dat['Rounded Value'] == 'NA'
              ? 0
              : parseFloat(dat['Rounded Value']);
        // Suppress value for non-superadmin below ISthreshold
        const sampleSizeVal = dat["Sample size"];
        if (this._configService.userRole != 'superadmin' && Number(sampleSizeVal) <= this._configService.ISthreshold) {
          value = 0;
        }
        // color logic: prefer dat.color, otherwise seriescolor or seriesgradientcolor
        const assignedColor = dat['color']
          ? dat['color']
          : (!isGradient ? this.seriescolor[i] : this.seriesgradientcolor[i]);
        this.fillColor.push(assignedColor);
        // also keep customcolors in sync if template reads from it
        if (this.customcolors && Array.isArray(this.customcolors)) {
          this.customcolors[i] = assignedColor;
        }

        this.data.push(dat['Rounded Value']);
        this.data2.push(value); // suppressed value used for rendering
        this.name.push(dat['Series Name']);
        this.cov.push(dat["Change value vs PY"]);
        this.significance.push(dat["Sig_LowerLimt"]);
        this.significance2.push(dat["Sig_UpperLimt"]);
        this.percentage.push(dat["isPercentage"]);
        this.Indexvalues.push(dat["ActualIndexValue"]);
        this.SignificanceValue.push(dat["Significance_Value"]);
        this.sampleSizes.push(dat["Sample size"]);
        i++;
      });
      this.maxdata = Math.max(...this.data);
    }
    else{
        this.data=[];
        this.name=[];
        this.data2=[];
        this.cov=[];
        this.significance=[]; 
        this.significance2=[];
        this.percentage=[];
        this.Indexvalues=[];
        this.SignificanceValue=[]; 
        this.sampleSizes=[];
        data.forEach((dat: any) => {
          let value =
            parseFloat(dat['Rounded Value']) == 0 ||
              parseFloat(dat['Rounded Value']) == null
              ? 0
              : parseFloat(dat['Rounded Value']);
          this.data.push(value);
          this.data2.push(value);
          this.name.push(dat['Category Name']);
          this.cov.push(dat["Change value vs PY"]);
          this.significance.push(dat["Significance"]);
          this.significance2.push(dat["Significance2"]);
          // No explicit sample size in demo JSON; push 0 as placeholder
          // this.sampleSizes.push(0);
           this.significance.push(dat["Sig_LowerLimt"] || dat["Significance"]);
          this.significance2.push(dat["Sig_UpperLimt"] || dat["Significance2"]);
          this.percentage.push(dat["isPercentage"] || false);
          this.Indexvalues.push(dat["ActualIndexValue"] || null);
          this.SignificanceValue.push(dat["Significance_Value"] || "-1");
          // Use sample size from data or default to 0
          this.sampleSizes.push(dat["Sample size"] || 0);
        });
        this.maxdata = Math.max(...this.data);
    }
  }

  
  plotChart(jsondata: any, chartproperties: any) {
    localStorage.setItem("properties", JSON.stringify(chartproperties));
    if(this.isOutput){
      if(this.uniquechartservice.color.length>0)
        this.customcolors =this.uniquechartservice.color;
    }
    this.filltomax=chartproperties.filltomax;
    chartproperties.dataLabelSize-=0.2;
    // const fillChartElement = document.getElementById(chartproperties.chartStyle == 'style1' ? 'parentDiv' : 'parentDiv2');
    // const titleElement = document.getElementById('title');
    // const imageElement = document.getElementById('image');
    // const fillChartElement1 = document.getElementById('childDiv1');
    // //code to get all elements with id categoryname and datalabel
    // const categoryNames = document.querySelectorAll('#categoryname');
    // const dataLabels = document.querySelectorAll('#datalabel');
    if(this.isOutput){
      this.preparemainChartData(this.customData);

      // Remove entries where Label is NA (null data from API)
      this.chartMainData = this.chartMainData.filter((d: any) => d['Label'] !== 'NA' && d['Label'] !== null && d['Label'] !== undefined);

      if (this.chartMainData.length === 0) {
        this.notApplicable = true;
        return;
      }

      this.notApplicable = false;
      this.preparechartdata(this.chartMainData);
    }
    else{
       this.preparechartdata(jsondata);
    }

    // for (let i = 0; i < categoryNames.length; i++) {
    //   const categoryNameElement = categoryNames[i] as HTMLElement;
    //   categoryNameElement.style.color = chartproperties.darkTheme ? 'white' : 'black';
    //   // const datalabelelemnt = dataLabels[i] as HTMLElement;
    //   // datalabelelemnt.style.color = chartproperties.darkTheme ? 'white' : 'black';
    // }
    // //datalabel
    // // let m=chartproperties.chartStyle == 'style1' ? 0 :(chartproperties.chartStyle == 'style2' ? 3 : (chartproperties.chartStyle == 'style3' ? 6 : 9));
    // const datalabelelementstyle1 = Array.from(dataLabels).slice(0, 6) as any;
    // const datalabelelementstyle2 = Array.from(dataLabels).slice(3, 6) as any;
    // const datalabelelementstyle3 = Array.from(dataLabels).slice(6, 8) as any;
    // for (let i = 0; i < this.data.length; i++) {
    //   const datalabelelemnt = chartproperties.chartStyle=="style1"?datalabelelementstyle1[i] as HTMLElement:(chartproperties.chartStyle=="style2"?datalabelelementstyle2[i]as HTMLElement:datalabelelementstyle3[i]as HTMLElement) ;
    //   let text = '';
      
    //     if (this.data[i] < -1) { text = "Data cant be less than 0." }
    //     else {
    //       text = this.data[i] == 0 ? 'NA' : this.data[i] + (chartproperties.dataLabelFormat ? '%' : '');
    //       if (this.data[i] != 0) {
    //         let significanceunicode = this.significance[i] == "1" ? '\u25B2' : (this.significance[i] == "-1" ? '\u25BC' : '');
    //         if (chartproperties.datalabelStyle == "default") { text = text }
    //         if (chartproperties.datalabelStyle == "changeversus") { text = text + '<span style="font-size: 80%;color:'+(chartproperties.darkTheme?'white':'black')+'"> ('+(this.cov[i]>0?'+':'') + this.cov[i] + ') </span>' }
    //         if (chartproperties.datalabelStyle == "significance") { text = text + '<span style="color:' + (this.significance[i] == "1" ? 'green' : (this.significance[i] == "-1" ? 'red' : '')) + ';">' + significanceunicode + '</span>' }
    //         if (chartproperties.datalabelStyle == "changeversus+significance") { text = text + '<span style="font-size: 80%;color:'+(chartproperties.darkTheme?'white':'black')+'"> (' +(this.cov[i]>0?'+':'')+ this.cov[i] + ') </span>' + '<span style="color:' + (this.significance[i] == "1" ? 'green' : (this.significance[i] == "-1" ? 'red' : '')) + ';">' + significanceunicode + '</span>' }
    //         if (chartproperties.datalabelStyle == "significance2") { text = text + '<span style="font-size:80%;color:' + (this.significance2[i] == "1" ? 'green' : (this.significance2[i] == "-1" ? 'red' : '')) + '";> ( '+(this.cov[i]>0?'+':'') + this.cov[i] + ' )</span> <span style="color:' + (this.significance[i] == "1" ? 'green' : (this.significance[i] == "-1" ? 'red' : '')) + ';">' + significanceunicode + '</span>' }
    //       }
    //     }
      
    //   datalabelelemnt!.innerHTML = chartproperties.showDataLabel ? text : '';
    //   datalabelelemnt!.style.fontSize=chartproperties.dataLabelSize;
    // }

  }

  getValue(data:any,index:any){
    let text:any;
    if(this.isOutput){
      if(data!='NA' && data!=null)
        text=parseFloat(Number(data).toFixed(this.chartproperties.decimalRoundOff)).toString()+(this.percentage[index]?'%':'');
      else
        text='NA';
    }
    else
      
       text=parseFloat(Number(data).toFixed(this.chartproperties.decimalRoundOff));
  // Use per-item sample size if available; fallback to samplesizeconstant (if later configured)
  const sampleSize = this.sampleSizes && this.sampleSizes[index] != null ? this.sampleSizes[index] : this.samplesizeconstant;
  let textCheck = this._configService.CheckLSorIScondition(this._configService.userRole, String(text), Number(sampleSize));
     return textCheck;
  }

  scaledata(data:any){
    if(data==this.maxdata){
      return 0;
    }
    return 100-Math.min(100, (100 * data) / this.maxdata)
  }

  getChangeVs(index:any){
    let text:any;
     if(this.chartproperties.datalabelStyle=="sigChange"){
       if(this.cov[index]!=null && this.cov[index]!='NA'){
           let value= this.percentage[index]?Number(this.cov[index])*100:Number(this.cov[index]);
           text='('+ parseFloat(Number(value).toFixed(1))+'%)';
       }
       else
        {
           // Determine LS/IS condition using stored sample size
           const sampleSize = this.sampleSizes && this.sampleSizes[index] != null ? this.sampleSizes[index] : this.samplesizeconstant;
           const lsisCheck = this._configService.CheckLSorIScondition(this._configService.userRole, 'NA', Number(sampleSize));
           // If result is I or S return empty string, else '(NA)'
           text = (lsisCheck =='I/S') ? '' : '(NA)';
        }
     }
     else if(this.chartproperties.datalabelStyle=="index"){
       if(this.Indexvalues[index]!=null && this.Indexvalues[index]!='NA')
           text='('+parseFloat(Number(this.Indexvalues[index]).toFixed(1))+')';
       else
        {
          const sampleSize = this.sampleSizes && this.sampleSizes[index] != null ? this.sampleSizes[index] : this.samplesizeconstant;
          const lsisCheck = this._configService.CheckLSorIScondition(this._configService.userRole, 'NA', Number(sampleSize));
          // Show (I) or (S) if those flags returned, otherwise (NA)
          text = (lsisCheck =='I/S') ? '(I/S)' : '(NA)';
        }
     }

     return text;
  }

  getSigColor(index:any){
     let sigClass:any='black';
     const configService = this._configService;
     if(this.chartproperties.datalabelStyle=="sigChange"){
         sigClass = this.SignificanceValue[index] < this.significance[index] ? 'red' : (this.SignificanceValue[index] > this.significance2[index] ? 'green' : 'black');
     }
     else{
         let text2 = this.Indexvalues[index] == null ? 'NA' : this.data[index] == -1 ? -1 : this.data[index] != null ? this.Indexvalues[index].toFixed(1) : 'NA';
         sigClass = configService.CheckIndexColoring(String(text2));
     }
     return sigClass;
  }

  oncheckboxchecked(event: any, checkboxchecked: any) {
    switch (checkboxchecked) {
      case 'Dark Theme':
        this.chartproperties.darkTheme = event.target.classList.toggle('checked');
        break;

      case 'Chart Style : ':
        this.chartproperties.chartStyle = event.target.value;
        break;

      case 'Fill Color : ':
        this.chartproperties.fillColor = event.target.value;
        break;

      case 'Background Color : ':
        this.chartproperties.backgroundColor = event.target.value;
        break;

      case 'Fill Direction : ':
        this.chartproperties.filldirection = event.target.value;
        break;
      
        case 'Fill To Max':
          this.chartproperties.filltomax = event.target.classList.toggle('checked');
          break;

      case 'Data Label : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.chartproperties.showDataLabel = value === 'enable' ? true : false;
        break;

      case 'Data Label Format : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.chartproperties.dataLabelFormat = value === 'num' ? false : true;
        break;

      case 'Data Label Property : ':
        this.chartproperties.datalabelStyle = event.target.value;
        break;

        case 'Data Label Color : ': {
          this.chartproperties['dataLabelColor'] = event.target.value;
          break;
        }

        case 'Data Label Size : ':
          this.chartproperties.dataLabelSize = event.target.value;
       break;
    }

    this.cdr.detectChanges();
    this.plotChart(this.jsondata['data'], this.chartproperties);
  }

  customization(): Observable<any> {
    // return this.piechartservice.PieChart1to10customizationList();
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("Fill Chart", snapshotTypeSelectedName, cohortType));
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.uniquechartservice.applycustomization(event, item, this.chartproperties)
    localStorage.setItem("properties", JSON.stringify(this.chartproperties));
    //this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
    //this.properties.ColumnHeaderFontSize="0.5em";
  }

  async userselectedproperties() {
    let base64ImageString = "";
    let element=this.chartproperties.chartStyle=="style1"?this.parentDiv:(this.chartproperties.chartStyle=="style2"?this.parentDiv2:this.parentDiv3)
    await html2canvas(element.nativeElement).then((canvas) => {
      base64ImageString = canvas.toDataURL('image/png');
    });
    let data = [{
      Data:this.jsondata['data'],
      Properties:[this.chartproperties],
      imageURL : base64ImageString,
    }]
    return JSON.stringify(data);
  }

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
  }
  
  get itemsPerPage(): number {
    return this.widgetCount === 7 ? 2 : 3;
  }
  fillPaginate(side: string) {
    if (side == 'left' && this.fillChartPage > 0) this.fillChartPage--;
    else if (side == 'right' && this.fillChartPage < this.totalPages - 1) this.fillChartPage++;
    this.cdr.detectChanges();
  }
  getFillIndex(i: number): number {
    return (this.widgetCount === 7 || this.widgetCount === 3)
    ? this.fillChartPage * this.itemsPerPage + i 
    : i;
  }
  get paginatedData(): any[] {
    const start = this.fillChartPage * this.itemsPerPage;
    return this.data.slice(start, start + this.itemsPerPage);
  }

  get totalPages(): number {
    return Math.ceil(this.data.length / this.itemsPerPage);
  }
}
